<script setup lang="ts">
import {computed, nextTick, onMounted, ref, useTemplateRef, watch} from "vue";
import {useUserStore} from "@/stores/userStore";
import {trackEvent} from "@/services/event.service";

const model = defineModel()
const userStore = useUserStore();
const props = defineProps({
  title: String,
  range: {
    type: Array<number>,
    required: true,
  },
  bin: {
    type: Array<number>,
    default: [],
    required: true,
  },
  type: {
    type: String,
    default: 'number',
    validator: (value: string) => ['number', 'currency', 'length'].includes(value),
  },
  event_id: {
    type: String,
  },
  event_label: {
    type: String,
  },
})

const bin = ref(props.bin)

const histogramData = computed(() => {
  let data = []
  bin.value.forEach((b) => {
    data = data.concat(Array(b.count).fill(b.min))
  })
  return data

});
const histogramMinValue = computed(() => {
  return bin.value[0].min
})

const histogramMaxValue = computed(() => {
  return bin.value[bin.value.length - 1].max
})

const histogramRef = useTemplateRef('histogramRef')
const prettify = function (value) {
  if (props.type == 'currency') {
    return userStore.formatCurrency(value)
  }

  if (props.type == 'length') {
    return userStore.formatLength(value)
  }
  return Math.round(value)
}

const update = (args) =>{
  trackEvent(`cosmosy.ga.filters.${props.event_id}`,
      {event_label: `${props.event_label}`, value_min: args.from,
        value_max: args.to}
  );
  model.value = [args.from, args.to]
}

watch(model,(value)=>{
  histogramRef.value.update({from:value[0],to:value[1]})
})

onMounted(() => {
  nextTick(()=>{
    histogramRef.value.update({from:model.value[0],to:model.value[1]})
  })
})
</script>
<template>
  <div class="flex flex-col " v-if="bin.length > 0">
    <div class="font-bold responsive-title-6">{{ props.title }}</div>
    <div class="flex-auto">
      <HistogramSlider
          ref="histogramRef"
          width="100%"
          primaryColor="#7fb0f9"
          handleColor="#000000"
          labelColor="#000000"
          :handleSize="14"
          type="double"
          :grid="false"
          :forceEdges="true"
          :clip="false"
          :dragInterval="true"
          :bar-height="100"
          :bar-width="2"
          :lineHeight="2"
          :min="histogramMinValue"
          :max="histogramMaxValue"
          :data="histogramData"
          :prettify="prettify"
          @finish="update"
      />
    </div>
  </div>
  <div v-else>
    <el-skeleton animated :rows="1"/>
  </div>
</template>
